module.exports = __webpack_public_path__ + "media/Video 148.8a2c89f2.mp4";